import React, {Component} from 'react';
import {connect} from 'react-redux'
import {RaisedButton} from 'material-ui'
import PropTypes from 'prop-types';
import axios from 'axios'
import {getAuthorizationHeader} from 'store/auth/utils'
import CircularProgress from "material-ui/CircularProgress";

class ExportButton extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = { loading : false }
    }

    render() {
        return (
            <RaisedButton primary={true} onClick={this.onBtnClick} label={this.props.label}>
                {  this.state.loading ? <CircularProgress size={24} color={'grey'} style={{marginTop:'6px', marginLeft:'15px'}}/> : ''}
            </RaisedButton>
        )
    }

    onBtnClick = () => {
        this.setState({ loading : true });
        axios.get(this.props.downloadUrl, {
            headers: getAuthorizationHeader(this.props.auth),
        }).then((response) => {
            this.setState({ loading : false });
            const csvContent = this.props.contentType + response.data[this.props.extension];
            const encodedUri = encodeURI(csvContent);
            let link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("style", "display:none")
            link.setAttribute("download", `${this.props.package.name}.${this.props.extension}`);
            link.innerHTML= "Click Here to download";
            document.body.appendChild(link); // Re
            link.click();
            link.remove();
            // window.open(encodedUri, '_blank')

        }).catch((error) => {
            console.log(error.response);
        });

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}


ExportButton.propTypes = {
    'package': PropTypes.object.isRequired
}

export default connect(mapStateToProps)(ExportButton);





// WEBPACK FOOTER //
// ./src/components/packages/export/ExportButton.js